import {
  AdminInput,
  AdminInputPlaceholder,
  AdminPhoneInput,
  CreateManualDeliveryAddressData,
  Div,
  formatSSN,
  isPartner,
  Label,
  P,
  Tab,
} from '@vgrubs/components';
import { AccountType } from '../../hooks/useWalletV2';
import {
  AddressInput,
  ConfirmAddressInput,
} from 'components/src/adminPages/Deliveries/components/ManualDeliveryAddress';
import { Dispatch, SetStateAction, useState } from 'react';

export const AboutYou = ({
  firstName,
  lastName,
  email,
  setFirstName,
  setLastName,
  setEmail,
  phoneNumber,
  setPhoneNumber,
  accountType,
  setAccountType,
  ssn,
  setSsn,
  setAddressObject,
  addressObject,
  formattedAddress,
  setLoading,
}: {
  firstName: string;
  lastName: string;
  email: string;
  setFirstName: Dispatch<SetStateAction<string>>;
  setLastName: Dispatch<SetStateAction<string>>;
  setEmail: Dispatch<SetStateAction<string>>;
  phoneNumber: string;
  setPhoneNumber: Dispatch<SetStateAction<string>>;
  accountType: AccountType;
  setAccountType: Dispatch<SetStateAction<AccountType>>;
  ssn: string;
  setSsn: Dispatch<SetStateAction<string>>;
  setAddressObject: Dispatch<
    SetStateAction<CreateManualDeliveryAddressData | null>
  >;
  addressObject: CreateManualDeliveryAddressData | null;
  formattedAddress: string;
  setLoading: Dispatch<SetStateAction<boolean>>;
}) => {
  const [changeAddressModal, setChangeAddressModal] = useState(false);
  const [confirmAddressModal, setConfirmAddressModal] =
    useState<CreateManualDeliveryAddressData | null>(null);

  const handleSetAddress = (address: any) => {
    setAddressObject(address);
    setConfirmAddressModal(null);
    setChangeAddressModal(false);
  };

  const handleSetAccountType = (type: AccountType) => {
    setAccountType(type);
    if (type === AccountType.individual) {
      setSsn('');
    }
  };

  return (
    <Div $flex $column $gap="24px">
      <P $m="0">
        Let’s start with {isPartner ? 'your' : 'this account'} basic info.
      </P>
      <Div $width="100%">
        <Label label="Choose Bank Account Type" $textCenter />
        <Div $flex $gap="16px" $width="100%">
          <Tab
            $minWidthAuto
            $width="calc(50% - 8px)"
            $widthSM="calc(50% - 8px)"
            selected={accountType === AccountType.individual}
            onClick={() => handleSetAccountType(AccountType.individual)}
          >
            Individual
          </Tab>
          <Tab
            $minWidthAuto
            $width="calc(50% - 8px)"
            $widthSM="calc(50% - 8px)"
            selected={accountType === AccountType.business}
            onClick={() => handleSetAccountType(AccountType.business)}
          >
            Business
          </Tab>
        </Div>
      </Div>{' '}
      <AdminInput
        label="First Name"
        placeholder="Enter Here"
        value={firstName}
        onChange={({ target }) => setFirstName(target.value)}
        $textCenter
      />
      <AdminInput
        label="Last Name"
        placeholder="Enter Here"
        value={lastName}
        onChange={({ target }) => setLastName(target.value)}
        $textCenter
      />
      <AdminInput
        type="email"
        label="Email"
        placeholder="Enter Here"
        value={email}
        onChange={({ target }) => setEmail(target.value)}
        $textCenter
      />
      <AdminInputPlaceholder
        value={addressObject ? formattedAddress : null}
        label="Address"
        placeholder="Enter address"
        $textCenter
        onClick={() => setChangeAddressModal(true)}
      />
      <AdminPhoneInput
        label="Phone Number"
        value={phoneNumber}
        onChange={(value) => setPhoneNumber(value)}
        $textCenter
      />
      {accountType === AccountType.individual && (
        <AdminInput
          label="SSN"
          placeholder="XXX-XX-XXXX"
          value={ssn}
          onChange={({ target }) => setSsn(formatSSN(target.value))}
          $textCenter
        />
      )}
      <AddressInput
        modalIsOpen={changeAddressModal}
        setModalIsOpen={setChangeAddressModal}
        setLoading={setLoading}
        setConfirmAddressModal={setConfirmAddressModal}
        title={'Billing Address'}
        inputLabel={'New Billing Address'}
        placeholder={'Enter address'}
      />
      <ConfirmAddressInput
        modalIsOpen={confirmAddressModal}
        setModalIsOpen={setConfirmAddressModal}
        handleConfirmAddress={handleSetAddress}
        title={'Confirm Billing Address'}
      />
    </Div>
  );
};
